import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStaticDataReducer from '../reducers';
import * as staticDataBusinessGroupsReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion


export const getStaticDataBusinessGroupsState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataBusinessGroupsReducer.staticDataBusinessGroupsFeatureKey]
);

export const getStaticDataBusinessGroupsFailure = createSelector(
  getStaticDataBusinessGroupsState,
  staticDataBusinessGroupsReducer.fromStaticDataBusinessGroupsReducer.getStaticDataBusinessGroupsFailure
);

export const getStaticDataBusinessGroupsResponse = createSelector(
  getStaticDataBusinessGroupsState,
  staticDataBusinessGroupsReducer.fromStaticDataBusinessGroupsReducer.getStaticDataBusinessGroupsResponse
);
